import type { ResultOf } from '@graphql-typed-document-node/core';

import { query } from '../../common/requests/base.query.ts';
import { ResultType } from '../../main/types/result.types.ts';
import { getReadingCrittersClientUtil } from '../../main/utils/clients/readingcritters.client.util.ts';

const FETCH_CHILD_PROFILES_QUERY = query({
  listChildProfiles: {
    childProfiles: {
      id: true,
      name: true,
      age: true,
      incorrectHelpThreshold: true,
    },
  },
});

type FetchChildProfilesResponseType = ResultOf<typeof FETCH_CHILD_PROFILES_QUERY>['listChildProfiles']['childProfiles'];

export const fetchChildProfilesQueryRequest = async (): Promise<ResultType<FetchChildProfilesResponseType>> => {
  const client = getReadingCrittersClientUtil();

  try {
    const response = await client.query(FETCH_CHILD_PROFILES_QUERY, {}, ['listChildProfiles'], { useAuth: true });

    return {
      success: true,
      data: response?.listChildProfiles?.childProfiles ?? [],
    };
  } catch (error) {
    return {
      success: false,
      message: (error as Error).message,
    };
  }
};
